function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M214.384 8.774l-.072-1.133c-.009-.149-.009-.328-.017-.537h-.017c-.051.17-.111.399-.162.574l-.355 1.07h-.392l-.345-1.103c-.039-.142-.094-.37-.137-.541h-.021c0 .177-.009.363-.017.537l-.069 1.133h-.367l.137-1.922h.58l.329.943c.043.145.085.286.132.484h.004c.051-.177.094-.339.137-.48l.333-.947h.55l.149 1.922h-.38zm-2.081-1.922v.316h-.614v1.606h-.389V7.168h-.614v-.316h1.617zM41.94 6.852h14.44v4.835h-9.478v3.442h7.848v4.516h-7.848v6.654h-4.961zM65.64 26.299h4.987V6.852h-4.986zM79.896 6.852h4.96v14.635h9.33V26.3h-14.29zM102.222 6.852h14.938v4.835h-9.952v2.796h8.181v4.511h-8.18v2.493h9.95V26.3h-14.937zM132.2 26.299l-7.857-19.447h5.434l4.888 13.066 4.914-13.066h5.435L137.135 26.3zM152.445 26.299h4.986V6.852h-4.986zM166.695 26.299V6.852h4.236l8.68 10.873V6.852h4.961V26.3h-4.214l-8.676-10.845v10.845zM193.837 6.852h14.938v4.835h-9.951v2.796h8.181v4.511h-8.181v2.493h9.951V26.3h-14.938zM8 18l7.722 15L19 26.632 14.56 18zM3 7l2.787 6H12L9.217 7zM6 1l2.767 6h19.467L31 1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 1l2.775 6H9L6.222 1zM23.217 19L26 13H12l2.779 6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.776 19H15l-2.775-6H6z"
}));

var SvgLogoWhite = function SvgLogoWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 34,
    viewBox: "0 0 217 34",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-white.102f4bdc.svg";
export { ForwardRef as ReactComponent };